import { HTML_LINK_TARGET } from '../../../../../constants/html'
import { useInitData, useLinkLikeClick } from '../../../../../hooks'
import { getBudgetPlanProfilePathname } from '../../../../../utils/link'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileCreateInvoiceAction() {
  const { availableSections } = useInitData()

  const { requestData } = useRequestProfileContext()

  const { handleClick: handleLinkClick } = useLinkLikeClick()

  function handleClickCreateInvoice(event) {
    const link = getBudgetPlanProfilePathname({
      availableSections,
      id: requestData.budgetPlan?.id,
      requestId: requestData.id,
    })

    handleLinkClick({ event, link, target: HTML_LINK_TARGET.blank })
  }

  return { handleClickCreateInvoice }
}
